import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../css/PromotionPrize.css"
import { toast } from "react-toastify";

/* =========================
   🎁 PRIZE POOLS
========================= */

// 500 – 1,500 ONLY
const lowOnlyPrizes = [
  { type: "Airtime", value: 500 },
  { type: "Airtime", value: 1000 },
  { type: "Airtime", value: 1500 },

  { type: "Scratch Ticket", value: 500 },
  { type: "Scratch Ticket", value: 1000 },

  { type: "Store Credit", value: 1000 },
  { type: "Store Credit", value: 1500 },
];

// 500 – 3,000
const midRangePrizes = [
  ...lowOnlyPrizes,
  { type: "Airtime", value: 2000 },
  { type: "Airtime", value: 2500 },
  { type: "Airtime", value: 3000 },
];

// HIGH VALUE (RARE)
const highPrizes = [
  { type: "Airtime", value: 3500 },
  { type: "Airtime", value: 4000 },
  { type: "Airtime", value: 4500 },
  { type: "Airtime", value: 5000 },
  { type: "Store Credit", value: 2000 },
  { type: "Store Credit", value: 2500 },
];

/* =========================
   🎲 WEIGHTED PICKER
========================= */

const pickWeightedPrize = () => {
  const roll = Math.random();

  // ~80% chance → mid range (500–3000)
  if (roll < 0.8) {
    return midRangePrizes[Math.floor(Math.random() * midRangePrizes.length)];
  }

  // ~20% chance → high prize
  return highPrizes[Math.floor(Math.random() * highPrizes.length)];
};

/* =========================
   🧾 COMPONENT
========================= */

const PromotionPrize = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const [prizes, setPrizes] = useState([]);
  const [generated, setGenerated] = useState(false);

  if (!state) {
    return (
      <div className="promotion-manager">
        <p>No receipt data found. Please scan again.</p>
        <button onClick={() => navigate("/promotions")}>
          🔙 Back to Scan
        </button>
      </div>
    );
  }

  const total = Number(state.total);

  // 🔢 DETERMINE PRIZE COUNT & POOL
  let prizeCount = 0;
  let prizeGenerator = null;

  if (total >= 10000 && total <= 59999) {
    prizeCount = 1;
    prizeGenerator = () =>
      lowOnlyPrizes[Math.floor(Math.random() * lowOnlyPrizes.length)];
  } else if (total >= 60000 && total <= 99999) {
    prizeCount = 2;
    prizeGenerator = () =>
      midRangePrizes[Math.floor(Math.random() * midRangePrizes.length)];
  } else if (total >= 100000) {
    prizeCount = 5;
    prizeGenerator = pickWeightedPrize;
  }

  const generatePrizes = () => {
    if (generated) return;

    if (prizeCount === 0) {
      toast.error("❌ Receipt not eligible for promotion");
      return;
    }

    const generatedPrizes = [];

    for (let i = 0; i < prizeCount; i++) {
      generatedPrizes.push(prizeGenerator());
    }

    setPrizes(generatedPrizes);
    setGenerated(true);

    toast.success(`🎉 ${generatedPrizes.length} prize(s) generated`);
  };

  const printTicket = () => {
    window.print();
  };

  return (
    <div className="promotion-manager">
      <h2>🎁 Prize Redemption</h2>

      <div className="receipt-details">
        <p><strong>Receipt:</strong> {state.receipt_no}</p>
        <p><strong>Customer:</strong> {state.customer_name || "Unknown"}</p>
        <p><strong>Amount Spent:</strong> ${total.toLocaleString()}</p>
        <p><strong>Eligible Prizes:</strong> {prizeCount}</p>
      </div>

      {!generated && (
        <button className="proceed-btn" onClick={generatePrizes}>
          🎲 Generate Prize{prizeCount > 1 ? "s" : ""}
        </button>
      )}

{generated && (
  <div className="receipt-details print-ticket">
    <h3>🏆 Prizes Won</h3>

    <ul>
      {prizes.map((p, index) => (
        <li key={index}>
          🎁 Prize {index + 1}:{" "}
          <strong>
            {p.type} – ${p.value.toLocaleString()}
          </strong>
        </li>
      ))}
    </ul>

    <button className="proceed-btn no-print" onClick={printTicket}>
      🖨️ Print Ticket
    </button>

    <button
      className="secondary-btn no-print"
      onClick={() => navigate("/promotions")}
    >
      🔄 New Redemption
    </button>
  </div>
)}

    </div>
  );
};

export default PromotionPrize;
